const config =
	typeof window !== "undefined" ? require("./client-side").default : require("./server-side");

const gpApiConfig = () => config;

export default gpApiConfig;
